import * as Types from '../../../../../__generated__/schema';

import { AlertDetailsFull } from '../../../../graphql/fragments/AlertDetailsFull.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AlertDetailsVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type AlertDetails = {
  alert: {
    origin:
      | Pick<
          Types.AlertOriginPolicy,
          'policyId' | 'resourceTypes' | 'resourceId' | 'policySourceId' | 'dedupString'
        >
      | Pick<
          Types.AlertOriginReplayedRule,
          'ruleId' | 'logTypes' | 'replayId' | 'dedupString' | 'eventsMatched' | 'scheduledQueries'
        >
      | Pick<
          Types.AlertOriginRule,
          'ruleId' | 'logTypes' | 'scheduledQueries' | 'eventsMatched' | 'dedupString'
        >
      | (Pick<Types.AlertOriginSystemError, 'type' | 'relatedComponent'> & {
          relatedEntity?: Types.Maybe<
            | (Pick<
                Types.AmazonSecurityLakeLogIntegration,
                'integrationId' | 'integrationLabel' | 'integrationType'
              > & {
                alarms: {
                  eventThreshold?: Types.Maybe<Pick<Types.EventThresholdAlarm, 'minutesThreshold'>>;
                };
              })
            | (Pick<
                Types.AzureEventHubSourceIntegration,
                'integrationId' | 'integrationLabel' | 'integrationType'
              > & {
                alarms: {
                  eventThreshold?: Types.Maybe<Pick<Types.EventThresholdAlarm, 'minutesThreshold'>>;
                };
              })
            | (Pick<
                Types.CloudWatchLogIntegration,
                'integrationId' | 'integrationLabel' | 'integrationType'
              > & {
                alarms: {
                  eventThreshold?: Types.Maybe<Pick<Types.EventThresholdAlarm, 'minutesThreshold'>>;
                };
              })
            | Pick<Types.CorrelationRule, 'id' | 'analysisType'>
            | Pick<Types.Destination, 'outputId' | 'displayName'>
            | Pick<Types.EnrichmentIntegration, 'integrationId' | 'integrationLabel'>
            | (Pick<
                Types.EventBridgeIntegration,
                'integrationId' | 'integrationLabel' | 'integrationType'
              > & {
                alarms: {
                  eventThreshold?: Types.Maybe<Pick<Types.EventThresholdAlarm, 'minutesThreshold'>>;
                };
              })
            | (Pick<
                Types.GcpPubSubLogSourceIntegration,
                'integrationId' | 'integrationLabel' | 'integrationType'
              > & {
                alarms: {
                  eventThreshold?: Types.Maybe<Pick<Types.EventThresholdAlarm, 'minutesThreshold'>>;
                };
              })
            | (Pick<
                Types.GcsLogSourceIntegration,
                'integrationId' | 'integrationLabel' | 'integrationType'
              > & {
                alarms: {
                  eventThreshold?: Types.Maybe<Pick<Types.EventThresholdAlarm, 'minutesThreshold'>>;
                };
              })
            | (Pick<
                Types.HttpLogSourceIntegration,
                'integrationId' | 'integrationLabel' | 'integrationType'
              > & {
                alarms: {
                  eventThreshold?: Types.Maybe<Pick<Types.EventThresholdAlarm, 'minutesThreshold'>>;
                };
              })
            | (Pick<
                Types.LogPullingIntegration,
                'integrationId' | 'integrationLabel' | 'integrationType'
              > & {
                alarms: {
                  eventThreshold?: Types.Maybe<Pick<Types.EventThresholdAlarm, 'minutesThreshold'>>;
                };
              })
            | (Pick<
                Types.OTLPLogSourceIntegration,
                'integrationId' | 'integrationLabel' | 'integrationType'
              > & {
                alarms: {
                  eventThreshold?: Types.Maybe<Pick<Types.EventThresholdAlarm, 'minutesThreshold'>>;
                };
              })
            | Pick<Types.Rule, 'id' | 'analysisType'>
            | (Pick<
                Types.S3LogIntegration,
                'integrationId' | 'integrationLabel' | 'integrationType'
              > & {
                alarms: {
                  eventThreshold?: Types.Maybe<Pick<Types.EventThresholdAlarm, 'minutesThreshold'>>;
                };
              })
            | (Pick<
                Types.SqsLogSourceIntegration,
                'integrationId' | 'integrationLabel' | 'integrationType'
              > & {
                alarms: {
                  eventThreshold?: Types.Maybe<Pick<Types.EventThresholdAlarm, 'minutesThreshold'>>;
                };
              })
          >;
        })
      | Pick<Types.Detection, 'id'>
      | Pick<Types.SystemError, 'relatedComponent'>;
  } & AlertDetailsFull;
};

export const AlertDetailsDocument = gql`
  query AlertDetails($id: ID!) {
    alert(id: $id) {
      ...AlertDetailsFull
      origin {
        ... on AlertOriginPolicy {
          policyId
          resourceTypes
          resourceId
          policySourceId
          dedupString
        }
        ... on AlertOriginRule {
          ruleId
          logTypes
          scheduledQueries
          eventsMatched
          dedupString
        }
        ... on AlertOriginReplayedRule {
          ruleId
          logTypes
          replayId
          dedupString
          eventsMatched
          scheduledQueries
        }
        ... on AlertOriginSystemError {
          type
          relatedComponent
          relatedEntity {
            ... on HttpLogSourceIntegration {
              integrationId
              alarms {
                eventThreshold {
                  minutesThreshold
                }
              }
              integrationLabel
              integrationType
            }
            ... on OTLPLogSourceIntegration {
              integrationId
              alarms {
                eventThreshold {
                  minutesThreshold
                }
              }
              integrationLabel
              integrationType
            }
            ... on S3LogIntegration {
              integrationId
              alarms {
                eventThreshold {
                  minutesThreshold
                }
              }
              integrationLabel
              integrationType
            }
            ... on EventBridgeIntegration {
              integrationId
              alarms {
                eventThreshold {
                  minutesThreshold
                }
              }
              integrationLabel
              integrationType
            }
            ... on AmazonSecurityLakeLogIntegration {
              integrationId
              alarms {
                eventThreshold {
                  minutesThreshold
                }
              }
              integrationLabel
              integrationType
            }
            ... on LogPullingIntegration {
              integrationId
              alarms {
                eventThreshold {
                  minutesThreshold
                }
              }
              integrationLabel
              integrationType
            }
            ... on SqsLogSourceIntegration {
              integrationId
              alarms {
                eventThreshold {
                  minutesThreshold
                }
              }
              integrationLabel
              integrationType
            }
            ... on CloudWatchLogIntegration {
              integrationId
              alarms {
                eventThreshold {
                  minutesThreshold
                }
              }
              integrationLabel
              integrationType
            }
            ... on GcsLogSourceIntegration {
              integrationId
              alarms {
                eventThreshold {
                  minutesThreshold
                }
              }
              integrationLabel
              integrationType
            }
            ... on GcpPubSubLogSourceIntegration {
              integrationId
              alarms {
                eventThreshold {
                  minutesThreshold
                }
              }
              integrationLabel
              integrationType
            }
            ... on HttpLogSourceIntegration {
              integrationId
              alarms {
                eventThreshold {
                  minutesThreshold
                }
              }
              integrationLabel
              integrationType
            }
            ... on OTLPLogSourceIntegration {
              integrationId
              alarms {
                eventThreshold {
                  minutesThreshold
                }
              }
              integrationLabel
              integrationType
            }
            ... on AzureEventHubSourceIntegration {
              integrationId
              alarms {
                eventThreshold {
                  minutesThreshold
                }
              }
              integrationLabel
              integrationType
            }
            ... on EnrichmentIntegration {
              integrationId
              integrationLabel
            }
            ... on Destination {
              outputId
              displayName
            }
            ... on Rule {
              id
              analysisType
            }
            ... on CorrelationRule {
              id
              analysisType
            }
          }
        }
        ... on Detection {
          id
        }
        ... on SystemError {
          relatedComponent
        }
      }
    }
  }
  ${AlertDetailsFull}
`;

/**
 * __useAlertDetails__
 *
 * To run a query within a React component, call `useAlertDetails` and pass it any options that fit your needs.
 * When your component renders, `useAlertDetails` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertDetails({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAlertDetails(
  baseOptions: Apollo.QueryHookOptions<AlertDetails, AlertDetailsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AlertDetails, AlertDetailsVariables>(AlertDetailsDocument, options);
}
export function useAlertDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AlertDetails, AlertDetailsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AlertDetails, AlertDetailsVariables>(AlertDetailsDocument, options);
}
export function useAlertDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AlertDetails, AlertDetailsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AlertDetails, AlertDetailsVariables>(
    AlertDetailsDocument,
    options,
  );
}
export type AlertDetailsHookResult = ReturnType<typeof useAlertDetails>;
export type AlertDetailsLazyQueryHookResult = ReturnType<typeof useAlertDetailsLazyQuery>;
export type AlertDetailsSuspenseQueryHookResult = ReturnType<typeof useAlertDetailsSuspenseQuery>;
export type AlertDetailsQueryResult = Apollo.QueryResult<AlertDetails, AlertDetailsVariables>;
export function mockAlertDetails({
  data,
  variables,
  errors,
}: {
  data: AlertDetails;
  variables?: AlertDetailsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: AlertDetailsDocument, variables },
    result: { data, errors },
  };
}
